export const locales = {
	noData: 'Pas de données.',
	btnText: 'Consulter les données externes'
};
